import * as React from 'react';
import { Metadata, Schema, SchemaField } from '../../types';
import { getPermission } from './getPermission';
import { Resource } from '../../enums/Resource';

export interface Props {
  resource: Resource | Schema | SchemaField;
  data?: Partial<Metadata>;
  children?: React.ReactElement;
  onAccessDenied?: any;
  onPermissionNotLoaded?: any;
  editControlAttribute?: string; // default is 'disabled'
  selectedWorkspace?: any;
  isEditMode?: boolean;
}

const AccessControl = ({
  children,
  onAccessDenied: AccessDenied,
  onPermissionNotLoaded: PermissionNotLoaded,
  editControlAttribute,
  ...props
}: Props) => {
  const permission = getPermission(props);
  if (permission == null) {
    if (PermissionNotLoaded) return <PermissionNotLoaded />;
    return null;
  }
  if (!permission.canView) {
    if (AccessDenied) return <AccessDenied />;
    return null;
  }
  if (!permission.canEdit && children) {
    return React.cloneElement(children, {
      [editControlAttribute || 'disabled']: true
    });
  }
  return children;
};

export default AccessControl;
